
<script>
  export let name
  export let position
  export let img
  export let web=false
</script>

<div  class="col-sm-3 col-lg-2 col-xl-2">
  <div class="single-person">
    <!-- <div class="person-image">
      <img src={img} alt="">

    </div> -->
    <div class="person-info">
      <h3 class="full-name">{name}</h3>
      <span class="speciality">{position}</span>
      <span class="speciality">Conference Organiser</span>
      {#if web == true}
        <span class="speciality">(Web Operations)</span>
      {/if}
    </div>
  </div>
</div>

<style>
  .single-person {
  margin-top: 30px;
  background-color: #f6f9ff;
  border-radius: 5px;
}

.single-person .person-image {
    position: relative;
    margin-bottom: 50px;
    border-radius: 50%;
    border: 4px dashed transparent;
    transition: padding .3s;
    padding: 0 30px;
}

.single-person .person-image img {
  width: 100%;
    border-radius: 50%;
}

.single-person .person-image .icon {
  position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%,50%);
    display: inline-block;
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background: linear-gradient(to right, #016cec, #00b5f7);
    color: #fff;
    border-radius: 50%;
    font-size: 24px;
}

.single-person .person-info .full-name {
  margin-bottom: 10px;
  font-size: 16px;
    font-weight: 160;
}

.single-person .person-info .speciality {
    text-transform: uppercase;
    font-size: 12px;
    color: #016cec;
}

</style>
